<template>
  <span>

      <b-button-group class="listActions float-right">

        <slot></slot>

        <b-button
            v-if="userAuth.validation.validationRead"
            :disabled="disableRead" @click="onReadAction" :class="{'opacity-0':disableRead}" size="sm"
            variant="outline">
        <b-icon icon="search" variant="primary"></b-icon>
      </b-button>

        <!--
        Botão update tem prioridade na exibição do link principal
        <b-button v-b-tooltip.hover title="Editar" v-if="userAuth.validation.validationUpdate" size="sm" variant="outline">
          <b-icon icon="pencil" variant="primary"></b-icon>
        </b-button>
        -->

      <b-button
          v-if="userAuth.validation.validationDelete"
          :disabled="disableDelete" @click="onDeleteAction" :class="{'opacity-0':disableDelete}"
          size="sm" variant="outline">
        <b-icon icon="trash" variant="danger"></b-icon>
      </b-button>

        <slot name="final-slot"></slot>




    </b-button-group>

  </span>
</template>
<script>

import ui from "@/assets/scripts/ui";
import {crudGeneral} from "@/services/resource/GeneralCRUD.service";

export default {
  name: 't-list-actions-default',
  data() {
    return {
      linkView: "",
      linkDelete: "",
      localIdRead: 0,
    }
  },
  props: {
    disableRead: {
      type: Boolean,
      default: false,
    },
    disableDelete: {
      type: Boolean,
      default: false,
    },
    userAuth: {
      type: Object,
      required: true
    },
    formPath: {
      type: String,
    },
    id: {
      type: Number,
      default: 0,
      required: true
    },
    deleteByConfirmId: {
      type: Number,
      default: 0,
    },
  },
  methods: {

    generateLinks(){

      this.localIdRead = this.id

      this.linkView = "/" + this.formPath + "/view/" + this.id

      this.linkDelete = "/" + this.formPath + "/remove/" + this.id

    },

    async onReadAction() {
      await ui.goPath(this, this.linkView)
    },

    async onDeleteAction() {
      if (this.deleteByConfirmId > 0) {

        ui.msgConfirmDelete(this, async () => {

          await crudGeneral.remove(this.formPath, this.deleteByConfirmId).then(() => {

            ui.toast(this, "Informação", "Exclusão realizada com sucesso!")
            this.$emit("reload")

          }).catch(error => alert(error))
        })
      } else {
        await ui.goPath(this, this.linkDelete)
      }
    }
  },
  mounted() {

   this.generateLinks()

  },
  watch:{

    id(){
      this.generateLinks()
    }

  }

}
</script>
